// extracted by mini-css-extract-plugin
export default {"PopupSupportCreate":"PopupSupportCreate_PopupSupportCreate__xk1vf","content":"PopupSupportCreate_content__6ynSk","blockContent":"PopupSupportCreate_blockContent__fnKse"};